<template>
  <div>
    <Smainl></Smainl>
    <div class="page_content">
      <div class="creative_detail_breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>分享案例</el-breadcrumb-item>
          <el-breadcrumb-item>案例详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div  class="case_detail_content">
        <div class="case_detail_content_imgs">
          <el-image
            :src="detailshow.cover_url"
            class="case_detail_content_img_item"
            :preview-src-list="[detailshow.cover_url]">
          </el-image>
          <span v-for="(v,key) in case_files" :key="key">
            <video v-if="v.suffix == 'mp4'" class="case_detail_content_img_video" :controls="true"
                   :src="v.url"></video>
            <el-image v-else :src="v.url" class="case_detail_content_img_item"
                      :preview-src-list="srcList">
            </el-image>
          </span>
        </div>
        <div class="case_detail_content_info">
          <div class="case_detail_content_info_title">{{detailshow.name?detailshow.name:"--"}}</div>
          <div class="case_detail_content_info_list">
            <div class="case_detail_content_info_list_item">
              <span class="case_detail_content_info_list_item_label">项目周期：</span>
              <span class="case_detail_content_info_list_item_value">{{detailshow.cycle?detailshow.cycle:"--"}}</span>
            </div>
            <div class="case_detail_content_info_list_item">
              <span class="case_detail_content_info_list_item_label">项目金额：</span>
              <span class="case_detail_content_info_list_item_value">{{detailshow.money_name?detailshow.money_name:"--"}}</span>
            </div>
            <div class="case_detail_content_info_list_item">
              <span class="case_detail_content_info_list_item_label">客户品牌：</span>
              <span class="case_detail_content_info_list_item_value">{{detailshow.brand_name?detailshow.brand_name:"--"}}</span>
            </div>
            <div class="case_detail_content_info_list_item">
              <span class="case_detail_content_info_list_item_label">所属行业：</span>
              <span class="case_detail_content_info_list_item_value">{{detailshow.industry_top_name?detailshow.industry_top_name:"--"}}-{{detailshow.industry_second_name?detailshow.industry_second_name:"--"}}</span>
            </div>
            <div class="case_detail_content_info_list_item">
              <span class="case_detail_content_info_list_item_label">所属创意类目：</span>
              <span class="case_detail_content_info_list_item_value">{{detailshow.category_second_name?detailshow.category_second_name:"--"}}</span>
            </div>
            <div class="case_detail_content_info_list_item">
              <span class="case_detail_content_info_list_item_label">服务内容：</span>
              <span class="case_detail_content_info_list_item_value" v-html="formatContent"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
/* eslint-disable */
import Smainl from '@/components/Smainl.vue'
import * as commfun from "@/common/common.js"
export default {
  name: 'Index',
  components: {
    Smainl,
  },
  data: function () {
    return {
      activeTab:"1",
      detailshow:[],//商品详情
      case_files:[],//图片视频
      serviceContent:"",//服务内容
      srcList: []
    };
  },

  mounted() {
    this.initDetail()
  },
  computed: {
    formatContent() {
      var selfthis=this
      return selfthis.serviceContent.replace(/\n/g, '<br>');
    }
  },
  methods: {
    //详情界面跳转
    initDetail:function (){
      var selfthis=this
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var id = urlParams.get('id');
      var url = "/adapi/share/detailAjax"
      commfun.ajaxPost(selfthis,url,{id:id},function (selfthis,data){
        selfthis.detailshow = data.case_detail
        selfthis.serviceContent = data.case_detail.service_content
        selfthis.case_files = data.case_files
        if (selfthis.case_files.length > 0) {
          for (var i = 0; i < selfthis.case_files.length; i ++) {
            if (selfthis.case_files[i].suffix != 'mp4') {
              selfthis.srcList.push(selfthis.case_files[i].url)
            }
          }
        }
      },function (selfthis,dataError){
        commfun.showMessage(selfthis,'warning',"错误："+dataError.msg)
      })
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/components/ShareDetail.vue